import { Button, Modal } from 'react-bootstrap';
import { useState, useRef,useEffect } from 'react';
import { Link, useNavigate  } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import axios from 'axios';
import { toast } from 'react-toastify';



const AddPayout = ({ show, onClose, onSuccess  }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [shift_time, setShiftTime] = useState([]);
    const [payment_mode_option, setPaymentModeOption] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL
    const [selectedShiftTime, setSelectedShiftTime] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const [deductions, setDeductions] = useState("");
    const [service_sttm, setServiceSTTMValue] = useState(new DateObject());
    const [errors, setErrors] = useState({});
    const [allStaff, setAllStaff] = useState([]);
    const [staff_name, setStaffName] = useState([]);
    const [mobileNumber, setMobileNumber] = useState("");
    const [designation, setDesignation] = useState("");
    const [amount, setAmount] = useState(0);
    const [netPay, setNetPay] = useState(0);
    const [description, setDescription] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const navigate = useNavigate();
    const status = selectedPaymentMode ? 1 : 0;
    // const shift_time = [
    //     { value: "1", label: "Morning Shift - I" },
    //     { value: "2", label: "Morning Shift - II" },
    //     { value: "3", label: "Morning Shift - III" },
    // ]

    // const staff_name = [
    //     { value: "1", label: "Riya" },
    //     { value: "2", label: "Mithra" },
    //     { value: "3", label: "preethi" },
    // ]
    // const payment_mode_option = [
    //     { value: "1", label: "Card" },
    //     { value: "2", label: "Cash" },
    //     { value: "3", label: "UPI" },
    //     { value: "4", label: "Gpay" },
    // ];
    const status_option = [
        { value: "1", label: "Pending" },
        { value: "2", label: "Paid" },
    ];
    const designation_option = [
        { value: "1", label: "Supervisor" },
        { value: "2", label: "Manager" },
        { value: "3", label: "Sales Executive" },
    ];

    const [total_days, settotal_days] = useState(30);
    const [present_days, setpresent_days] = useState(0);
    const [isVisible, setIsVisible] = useState(false); 

    const [selectedOption, setSelectedOption] = useState(null);
    const datePickerRef = useRef();

    useEffect(() => {
        axios.get(`${baseURL}/shifttime`)
            .then(response => {
            // console.log("API response:", response.data);
            setShiftTime(
                response.data.data.filter(item => item.status === 0).map(item => ({ value: item.sno, label: item.shifttime_name }))
            );
            // setHasFetched(true);
            })
            .catch(error => {
            console.error('There was an error fetching the payouts!', error);
            // setHasFetched(true);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/managestaff`, { params : { branch_id: branch_id } })
            .then(response => {
                setAllStaff(response.data.data); // save full data
            })
            .catch(error => {
                console.error('Error fetching staff data', error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/paymentmode/getactive`)
            .then(response => {
            // console.log("Payout methods fetched:", response.data);
            setPaymentModeOption(
                (response.data || []).map(item => ({ value: item.sno, label: item.paymentmode_name, transaction_id: item.transaction_id, }))
            );
            })
            .catch(err => console.error('Error fetching payment modes', err));
    }, []);

    const handlePaymentChange = (selectedOption) => {
        setSelectedPaymentMode(selectedOption);
        setIsVisible(selectedOption?.transaction_id === 0); // Show field only if transaction_id is 0
    };

    useEffect(() => {
        // console.log('Selected Shift:', selectedShiftTime);
        // console.log('All Staff:', allStaff);
        if(selectedShiftTime) {
            const filteredStaff = allStaff
                .filter(staff => staff.shift_time?.sno === selectedShiftTime.value) // adjust property name here
                .map(item => ({ value: item.sno, label: item.employee_name }));
            setStaffName(filteredStaff);
        } else {
            setStaffName([]);
        }
        // Reset selected staff & details when shift changes
        setSelectedStaff(null);
        setMobileNumber("");
        setDesignation("");
        setAmount(0);
        setNetPay(0);
    }, [selectedShiftTime, allStaff]);

    useEffect(() => {
        if(selectedStaff) {
            const staffDetails = allStaff.find(staff => staff.sno === selectedStaff.value);
            if(staffDetails) {
                setMobileNumber(staffDetails.phone_no);
                setDesignation(staffDetails.job_role.jobrole_name);
                setAmount(staffDetails.salary);
                // Calculate Net Pay immediately when staff selected or deductions change
                setNetPay(staffDetails.salary - (parseFloat(deductions) || 0));
            }
        } else {
            setMobileNumber("");
            setDesignation("");
            setAmount(0);
            setNetPay(0);
        }
    }, [selectedStaff, allStaff]);

    useEffect(() => {
        setNetPay(amount - (parseFloat(deductions) || 0));
    }, [deductions, amount]);

    useEffect(() => {
        if(selectedStaff) {
            console.log(selectedStaff);
            axios.get(`${baseURL}/get_deductions`, {params: {staff_id: selectedStaff.value}})
                .then(response => {
                    setDeductions(response.data.deduction);
                    settotal_days(response.data.total_days);
                    setpresent_days(response.data.present_days);
                })
                .catch(err => console.log('Error fetching payment modes', err));
        }
    }, [selectedStaff]);


    const handleClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!selectedShiftTime) newErrors.shiftTime = "This Field is required";
        if (!selectedStaff) newErrors.staff = "This Field is required";
        if (!selectedPaymentMode)
        newErrors.paymentMode = "This Field is required";
        if (!deductions) newErrors.deductions = "This Field is required";
        if(deductions > amount) newErrors.deductions = "Invalid amount";
        if(netPay <= 0) newErrors.netpay = "Invalid Amount";
        if (isVisible) {
            if (!transactionId){
                newErrors.trans = "This Field is Required.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    

    const handleSubmit = async () => {
        if (!validate()) return;

        const payload = {
            payout_date_time: service_sttm.format("YYYY-MM-DD HH:mm:ss"),
            shift_id: selectedShiftTime.value,
            staff_id: selectedStaff.value,
            payout_method: selectedPaymentMode ? Number(selectedPaymentMode.value) : null,
            deductions: parseFloat(deductions),
            net_pay: netPay,
            amount: amount,
            description: description,
            transaction_id: selectedPaymentMode?.value !== '2' ? transactionId : null,
            status: status,
            branch_id: branch_id
        };

        try {
            const response = await axios.post(`${baseURL}/managepayouts`, payload);
            toast.success("Payout created successfully!");
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error("Error creating payout:", error.response?.data || error.message);
            alert("Failed to create payout. Please check the data and try again.");
        }
    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Payout</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Date / Time<span className="required">*</span></label>
                            <div className="datepicker-wrapper d-flex" onClick={handleClick}>
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                </div>
                                <DatePicker
                                    ref={datePickerRef}
                                    value={service_sttm}
                                    onChange={setServiceSTTMValue}
                                    format="MM-DD-YYYY, hh:mm A"
                                    plugins={[
                                        <TimePicker position="bottom" />
                                    ]}
                                    disableDayPicker={false}
                                    className="custom-datepicker"
                                    maxDate={new Date(new Date().setHours(23, 59, 59, 999))}
                                />
                            </div>

                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Shift Time<span className="required">*</span></label>
                            <Select placeholder='Select Shift Time'
                                value={selectedShiftTime}
                                onChange={setSelectedShiftTime}
                                options={shift_time}
                            />
                            {errors.shiftTime && (<div className="text-danger fs-8 mt-1">{errors.shiftTime}</div>)}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                value={selectedStaff}
                                onChange={setSelectedStaff}
                                options={staff_name}
                            />
                            {errors.staff && (<div className="text-danger fs-8 mt-1">{errors.staff}</div>)}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile Number</label>
                            <input type="text" className="form-control" placeholder="Enter Mobile Number" value={mobileNumber} readOnly />
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Designation<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Designation" value={designation} readOnly />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Amount</label>
                            <input type="text" className="form-control" placeholder="Enter Amount" value={amount} readOnly />
                        </div>
                        
                        <div className="col-lg-6 mb-3 d-flex flex-column align-items-center justify-content-center">
                            <label className="text-black text-center font-w500 fs-7">Total Days</label>
                            <label className="text-black fs-6 font-w500">{total_days}</label>
                        </div>

                        <div className="col-lg-6 mb-3 d-flex flex-column align-items-center justify-content-center">
                            <label className="text-black text-center font-w500 fs-7">Present Days</label>
                            <label className="text-black fs-6 font-w500">{present_days}</label>
                        </div>

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Deductions<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Deductions" value={deductions}
                                onChange={(e) => setDeductions(e.target.value)}/>
                                {errors.deductions && (<div className="text-danger fs-8 mt-1">{errors.deductions}</div>)}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Net Pay</label>
                            <input type="text" className="form-control" placeholder="Enter Net Pay" value={netPay} readOnly />
                            {errors.netpay && (<div className="text-danger fs-8 mt-1">{errors.netpay}</div>)}
                        </div>

                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Payout Method<span className="required">*</span>
                            </label>
                            <Select
                                placeholder="Select Payout Mode"
                                value={selectedPaymentMode}
                                onChange={handlePaymentChange}
                                options={payment_mode_option}
                            />
                            {errors.paymentMode && (<div className="text-danger fs-8 mt-1">{errors.paymentMode}</div>)}
                        </div>

                        {isVisible && (
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Transaction ID<span className="required">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Transaction ID"
                                    value={transactionId}
                                    onChange={(e) => setTransactionId(e.target.value)}
                                />
                                {errors.trans && (<div className="text-danger fs-8 mt-1">{errors.trans}</div>)}
                            </div>
                        )}

                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" placeholder="Description" value={description}
                                onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Payout
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default AddPayout;